import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-chevron-right\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.6066 7.29287L6.65686 2.34314L5.94975 3.05025L10.8995 7.99998L5.94975 12.9497L6.65686 13.6568L11.6066 8.70708L11.6066 8.7071L12.3137 7.99999L12.3137 7.99998L12.3137 7.99996L11.6066 7.29285L11.6066 7.29287Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol